(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wishlist-icon"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'upphaar_wishlist';

    function getWishlist() {
      try { return JSON.parse(window.localStorage.getItem(KEY) || '[]'); }
      catch (e) { return []; }
    }
    function setWishlist(list) {
      try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      syncBadges();
      syncToggles();
    }
    function syncBadges() {
      var list = getWishlist();
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
        var n = el.querySelector('.upphaar-wishlist-count');
        if (n) n.textContent = list.length;
      });
    }
    function syncToggles() {
      var list = getWishlist();
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var active = list.indexOf(btn.getAttribute('data-handle')) !== -1;
        btn.classList.toggle('is-active', active);
        var icon = btn.querySelector('i');
        if (icon) {
          icon.classList.toggle('fa-solid', active);
          icon.classList.toggle('fa-regular', !active);
        }
      });
    }

    // Install a single delegated click handler for all wishlist toggle buttons.
    // Guarded so multiple renders of this snippet don't create duplicate listeners.
    if (!window.UpphaarWishlistDelegate) {
      window.UpphaarWishlistDelegate = true;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-wishlist-toggle]');
        if (!btn) return;
        var handle = btn.getAttribute('data-handle');
        if (!handle) return;
        e.preventDefault();
        e.stopPropagation();
        var list = getWishlist();
        var idx = list.indexOf(handle);
        if (idx === -1) list.push(handle);
        else list.splice(idx, 1);
        setWishlist(list);
      });
    }

    // Ensure active state is correct on page load.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncToggles);
    } else {
      syncToggles();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'upphaar_wishlist';

    function getWishlist() {
      try { return JSON.parse(window.localStorage.getItem(KEY) || '[]'); }
      catch (e) { return []; }
    }
    function updateBadges() {
      var list = getWishlist();
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
        var n = el.querySelector('.upphaar-wishlist-count');
        if (n) n.textContent = list.length;
      });
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var active = list.indexOf(btn.getAttribute('data-handle')) !== -1;
        btn.classList.toggle('is-active', active);
        var icon = btn.querySelector('i');
        if (icon) icon.classList.toggle('fa-solid', active);
        if (icon) icon.classList.toggle('fa-regular', !active);
      });
    }

    // Do NOT attach per-button click handlers here. The interactive toggle
    // behavior is handled by a single global delegated listener installed in
    // the `wishlist-icon` snippet. Attaching another handler here would cause
    // the list to be toggled twice per click (net: "button does nothing").
    // This snippet only keeps header/other badges in sync on load and across
    // tabs.
    updateBadges();

    // Keep badges in sync across browser tabs.
    window.addEventListener('storage', function (e) {
      if (e.key === KEY) updateBadges();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
